import script from "./Section.vue?vue&type=script&lang=ts&setup=true"
export * from "./Section.vue?vue&type=script&lang=ts&setup=true"

import "./Section.vue?vue&type=style&index=0&id=4c74b021&lang=scss"

const __exports__ = script;

export default __exports__